<template>
    <div class="main">
        <c-panel title="ATESTADOS DE VAGA" titleIcon="fas fa-file-signature">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="O atestado afirma que existe vaga. Se o quadro informado não tiver saldo, a emissão é recusada."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8"><el-input v-model="filtro.nome" placeholder="Candidato" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="24" :sm="8"><el-input v-model="filtro.numero" placeholder="Número do atestado" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="24" :sm="8" class="u-text-right">
                    <el-button icon="el-icon-search" @click="carregar">BUSCAR</el-button>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" @click="abrirNovo">NOVO ATESTADO</el-button>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 180px;">Número</th>
                            <th>Candidato</th>
                            <th class="hidden-mobile">Escola</th>
                            <th class="hidden-mobile">Curso / Turno</th>
                            <th class="u-text-center" style="width: 100px;">Emissão</th>
                            <th class="u-text-center" style="width: 110px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="a in items" :key="a.id">
                            <td>{{ a.numero }}</td>
                            <td>{{ a.aluno ? a.aluno.nome : a.nome_candidato }}</td>
                            <td class="hidden-mobile">{{ a.instituicao ? a.instituicao.nome : '' }}</td>
                            <td class="hidden-mobile">{{ a.curso ? a.curso.nome : '—' }} / {{ rotuloTurno(a.turno) }}</td>
                            <td class="u-text-center">{{ a.data_emissao | data }}</td>
                            <td class="u-text-center acao">
                                <el-button @click="imprimir(a.id)" title="Imprimir" type="info" icon="el-icon-printer" size="mini" plain></el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" @click="excluir(a.id)" title="Cancelar" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhum atestado emitido.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <el-dialog title="Emitir atestado de vaga" :visible.sync="dialogo" width="600px">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="Escola">
                                <el-select v-model="form.instituicao_id" filterable style="width: 100%;" @change="carregarQuadros">
                                    <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Período letivo">
                                <el-select v-model="form.periodo_letivo_id" style="width: 100%;" @change="carregarQuadros">
                                    <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Vaga (quadro de vagas)">
                        <el-select v-model="form.quadro_vaga_id" clearable style="width: 100%;" @change="aoEscolherQuadro">
                            <el-option v-for="q in quadros" :key="q.id" :value="q.id" :label="rotuloQuadro(q)"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Nome do candidato">
                        <el-input v-model="form.nome_candidato" maxlength="191"></el-input>
                    </el-form-item>
                    <el-row :gutter="10">
                        <el-col :xs="12">
                            <el-form-item label="Validade (opcional)">
                                <el-date-picker v-model="form.data_validade" type="date" value-format="yyyy-MM-dd"
                                    format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12">
                            <el-form-item label="Observação">
                                <el-input v-model="form.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvar">EMITIR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO D — item 53: atestado de vaga. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    filters: { data (v) { return v ? String(v).substring(0, 10).split('-').reverse().join('/') : '—' } },
    data: () => ({
        statusList: false, filtro: { nome: '', numero: '' }, items: [],
        instituicoes: [], quadros: [],
        dialogo: false,
        form: { instituicao_id: null, periodo_letivo_id: null, quadro_vaga_id: null,
                curso_id: null, turno: null, nome_candidato: '', data_validade: null, observacao: '' }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/atestado-vaga/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        abrirNovo () {
            const inst = this.$store.state.config.instituicao
            this.form = { instituicao_id: (inst && inst.id) ? inst.id : null,
                periodo_letivo_id: this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null,
                quadro_vaga_id: null, curso_id: null, turno: null, nome_candidato: '', data_validade: null, observacao: '' }
            this.quadros = []
            this.carregarQuadros()
            this.dialogo = true
        },
        carregarQuadros () {
            if (!this.form.instituicao_id || !this.form.periodo_letivo_id) return
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/quadro-vagas/getByInstituicao/${this.form.instituicao_id}/${this.form.periodo_letivo_id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.quadros = (r.data && r.data.itens) ? r.data.itens : [] }).catch(() => {})
        },
        aoEscolherQuadro () {
            const q = this.quadros.find(x => x.id === this.form.quadro_vaga_id)
            if (q) { this.form.curso_id = q.curso_id; this.form.turno = q.turno }
        },
        rotuloTurno (t) { return { 0: 'Matutino', 1: 'Vespertino', 2: 'Noturno', 4: 'Integral' }[t] || '—' },
        rotuloQuadro (q) {
            return (q.curso ? q.curso.nome : 'Todos') + ' · ' + this.rotuloTurno(q.turno) + ' · saldo ' + q.saldo
        },
        salvar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/atestado-vaga/store`,
                this.form, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Atestado emitido: ' + r.data.numero, type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir (id) { window.eventBus.$emit('print', { url: '/api/atestado-vaga/imprimir/' + id, param: null }) },
        excluir (id) {
            this.$confirm('Cancelar este atestado?', 'Confirmação', {
                confirmButtonText: 'Cancelar atestado', cancelButtonText: 'Voltar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/atestado-vaga/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(() => { window.eventBus.$emit('alert', { msg: 'Atestado cancelado.', type: 'success' }); this.carregar() })
                 .catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
